'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _event = require('../helpers/event');

var _i18n = require('../helpers/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _EventContact = require('./EventContact');

var _EventContact2 = _interopRequireDefault(_EventContact);

var _EventDate = require('./EventDate');

var _EventDate2 = _interopRequireDefault(_EventDate);

var _EventDescription = require('./EventDescription');

var _EventDescription2 = _interopRequireDefault(_EventDescription);

var _EventPrice = require('./EventPrice');

var _EventPrice2 = _interopRequireDefault(_EventPrice);

var _EventVenue = require('./EventVenue');

var _EventVenue2 = _interopRequireDefault(_EventVenue);

var _EventVideo = require('./EventVideo');

var _EventVideo2 = _interopRequireDefault(_EventVideo);

var _HeadingBlock = require('./HeadingBlock');

var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);

var _Page = require('./Page');

var _Page2 = _interopRequireDefault(_Page);

var _SelectionList = require('./SelectionList');

var _SelectionList2 = _interopRequireDefault(_SelectionList);

var _ShareLinks = require('./ShareLinks');

var _ShareLinks2 = _interopRequireDefault(_ShareLinks);

var _StaticMap = require('./StaticMap');

var _StaticMap2 = _interopRequireDefault(_StaticMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventDetailModernLayout = function EventDetailModernLayout(props) {
  var audienceAction = props.audienceAction,
      backButtonAction = props.backButtonAction,
      contact = props.contact,
      event = props.event,
      groupAction = props.groupAction,
      map = props.map,
      price = props.price,
      selectedDate = props.selectedDate,
      tagAction = props.tagAction,
      typeAction = props.typeAction;


  var subtitle = _react2.default.createElement(_SelectionList2.default, { available: event.types, labelKey: 'name', layout: 'commaSeparated', appearance: 'plain', action: typeAction });

  return _react2.default.createElement(
    _Page2.default,
    { title: event.title, subtitle: subtitle, backButtonAction: backButtonAction, className: 'EventDetail modern', layout: 'custom' },
    _react2.default.createElement(
      'section',
      { className: 'basics' },
      _react2.default.createElement(
        'div',
        { className: 'image', style: { backgroundImage: 'url(' + event.photo_url + ')' } },
        _react2.default.createElement(
          'time',
          { dateTime: (0, _moment2.default)(selectedDate.start_date).format('YYYY-MM-DDTHH:mm') },
          _react2.default.createElement(
            'span',
            { className: 'day' },
            (0, _moment2.default)(selectedDate.start_date).format('D')
          ),
          _react2.default.createElement(
            'span',
            { className: 'month' },
            (0, _moment2.default)(selectedDate.start_date).format('MMM')
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'tickets' },
        event.ticket_url && _react2.default.createElement(_Button2.default, { href: event.ticket_url, title: (0, _i18n2.default)('tickets'), type: 'primary', width: 'full', newWindow: true }),
        (0, _event.hasPrice)(event) && _react2.default.createElement(_EventPrice2.default, price)
      ),
      _react2.default.createElement(_EventDate2.default, { dates: event.dates, selectedDate: selectedDate, pathName: '/evenements/' + event.slug + '/' + event.id }),
      _react2.default.createElement(_EventVenue2.default, { venue: event.venue, room: event.room }),
      _react2.default.createElement(_StaticMap2.default, _extends({}, map, { width: 367, height: 412 }))
    ),
    _react2.default.createElement(
      'div',
      { className: 'detailsWrapper' },
      _react2.default.createElement(
        'section',
        { className: 'details' },
        _react2.default.createElement(
          'div',
          { className: 'description' },
          _react2.default.createElement(_EventDescription2.default, { description: event.description }),
          event.video && _react2.default.createElement(_EventVideo2.default, { html: event.video.html }),
          _react2.default.createElement(
            'div',
            { className: 'extras' },
            event.tags.length > 0 && _react2.default.createElement(_SelectionList2.default, { available: event.tags, labelKey: 'name', layout: 'inline', appearance: 'tag', action: tagAction }),
            _react2.default.createElement(_ShareLinks2.default, { event: event, icons: ['twitter', 'facebook', 'ical'] })
          )
        ),
        _react2.default.createElement(
          'aside',
          null,
          (0, _event.hasContact)(event) && _react2.default.createElement(
            _HeadingBlock2.default,
            { title: (0, _i18n2.default)('contact'), className: 'contact' },
            _react2.default.createElement(_EventContact2.default, contact)
          ),
          event.audiences.length > 0 && _react2.default.createElement(
            _HeadingBlock2.default,
            { title: (0, _i18n2.default)('audiences'), className: 'audiences' },
            _react2.default.createElement(_SelectionList2.default, { available: event.audiences, labelKey: 'name', appearance: 'plain', action: audienceAction })
          ),
          event.groups.length > 0 && _react2.default.createElement(
            _HeadingBlock2.default,
            { title: (0, _i18n2.default)('groups'), className: 'groups' },
            _react2.default.createElement(_SelectionList2.default, { available: event.groups, labelKey: 'name', appearance: 'plain', action: groupAction })
          )
        )
      )
    )
  );
};

EventDetailModernLayout.propTypes = {
  audienceAction: _propTypes2.default.func.isRequired,
  backButtonAction: _propTypes2.default.func.isRequired,
  contact: _propTypes2.default.object.isRequired,
  event: _propTypes2.default.object.isRequired,
  groupAction: _propTypes2.default.func.isRequired,
  map: _propTypes2.default.object.isRequired,
  price: _propTypes2.default.object.isRequired,
  selectedDate: _propTypes2.default.object.isRequired,
  tagAction: _propTypes2.default.func.isRequired,
  typeAction: _propTypes2.default.func.isRequired
};

exports.default = EventDetailModernLayout;
EventDetailModernLayout.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'EventDetailModernLayout',
  'props': {
    'audienceAction': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    },
    'backButtonAction': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    },
    'contact': {
      'type': {
        'name': 'object'
      },
      'required': true,
      'description': ''
    },
    'event': {
      'type': {
        'name': 'object'
      },
      'required': true,
      'description': ''
    },
    'groupAction': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    },
    'map': {
      'type': {
        'name': 'object'
      },
      'required': true,
      'description': ''
    },
    'price': {
      'type': {
        'name': 'object'
      },
      'required': true,
      'description': ''
    },
    'selectedDate': {
      'type': {
        'name': 'object'
      },
      'required': true,
      'description': ''
    },
    'tagAction': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    },
    'typeAction': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventDetailModernLayout.js
// module id = 610
// module chunks = 0